import { Box, Button, Radio, RadioGroup, FormControlLabel, Typography, useTheme, useMediaQuery, autocompleteClasses,Divider } from '@mui/material';
import React, { useState } from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import "./informedConsent.css";

const InformedConsent = ({ handleProceed, handleExit, handleMlConsentConsentChange,mlConsentGiven }) => {
    const [engContent, setEngContent] = useState(true);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [consentType, setConsentType] = useState('');

    const handleConsentChange = (event) => {
        const value = event.target.value;
        setConsentType(value);
        // Update the parent component with the ML consent status
        handleMlConsentConsentChange(value === 'ml');
    };

    const handlePopupClick = (event) => {
        event.stopPropagation();
    };

    const handleContentChange = () => {
        setEngContent(!engContent);
    }

    const getEngContent = () => {
        return(
            <Box>
                <Typography
                    paddingX="24px"
                    fontWeight={400}
                    fontSize="16px"
                >
                    The E-Health division of the Ministry of Health and Family Welfare,  Wadhwani AI—the AI Unit of the Lords Education and Health Society (LEHS)—in collaboration with AIIMS Delhi & AIIMS Rishikesh, has developed MadhuNetrAI, an AI-powered Diabetic Retinopathy (DR) solution to facilitate screening and timely referral of DR and DME. Designed for use across healthcare settings, this solution supports trained healthcare professionals—including Ophthalmologists, Optometrists, Medical Officers, Nursing Staff, and Community Health Officers—in enhancing eye care delivery.
                    <br/><br/>
                    All data collected, including fundoscopy scan images and health information, will be treated with utmost care and in compliance with data protection laws. Your health information will be kept strictly confidential and solely used for research purposes to enhance our product’s functionality, monitor disease progression, and facilitate follow-up screenings based on your screening results.<br/><br/>
                    By agreeing to participate, you acknowledge and understand the following:<br/><br/>
                    1. Fundoscopy scan images and relevant health information (including age, gender, diabetic status, vision issues, and patient ID) will be collected for screening purposes and can be used, in compliance with applicable data protection laws, to improve the AI model and support future research.
                    <br/><br/>
                    2. Your participation is voluntary, and you can withdraw your consent or discontinue participation at any time.
                    <br/>
                </Typography>
                <Typography
                    paddingX="24px"
                    fontWeight={600}
                    fontSize="18px"
                    component="h4"
                    marginTop="16px"
                >
                    Consent Declaration
                </Typography>
                <Typography
                    paddingX="24px"
                    fontWeight={400}
                    fontSize="16px"
                    marginTop="8px"
                    marginBottom="12px"
                >
                    By selecting one of the options below, you confirm that you have read and understood the provided information and voluntarily agree to participate:
                </Typography>
                <Typography
                    paddingX="24px"
                    fontWeight={400}
                    fontSize="16px"
                    marginBottom="12px"
                >
                    I consent to screening through MadhuNetrAI and allow my data (fundus image, age, gender, diabetic status, vision issues, patient ID) to be stored:
                </Typography>
            </Box>
        );
    };

    const getHinContent = () => {
        return(
            <Box>
                <Typography
                    paddingX="24px"
                    fontWeight={400}
                    fontSize="16px"
                >
                    स्वास्थ्य एवं परिवार कल्याण मंत्रालय के ई-हेल्थ विभाग, वाधवानी एआई—लॉर्ड्स एजुकेशन एंड हेल्थ सोसाइटी (LEHS) की एआई इकाई—एम्स दिल्ली एवं एम्स ऋषिकेश के सहयोग से, मधुनेत्रएआई (MadhuNetrAI) विकसित किया गया है, जो मधुमेह संबंधी नेत्र रोग (डायबिटिक रेटिनोपैथी) की स्क्रीनिंग एवं मधुमेह संबंधी नेत्र रोग के समय पर निदान के लिए एक एआई-संचालित समाधान है। स्वास्थ्य देखभाल के विभिन्न परिवेशों में उपयोग के लिए डिजाइन किया गया, यह समाधान प्रशिक्षित स्वास्थ्य पेशेवर विशेषज्ञ—जैसे नेत्र रोग विशेषज्ञ, ऑप्टोमेट्रिस्ट, चिकित्सा अधिकारी, नर्सिंग कर्मचारी एवं सामुदायिक स्वास्थ्य अधिकारी—को आंख की देखभाल में सहायता प्रदान करता है।<br /><br />
                    सभी एकत्र किए गए डेटा, जिसमें फंडोस्कोपी स्कैन चित्र एवं स्वास्थ्य संबंधी जानकारी शामिल है, को पूरी सावधानी एवं डेटा संरक्षण कानूनों के अनुपालन में रखा जाएगा। आपकी स्वास्थ्य संबंधी जानकारी को सख्त गोपनीय रखा जाएगा एवं केवल शोध उद्देश्यों के लिए उपयोग किया जाएगा, जिसमें हमारे एआई समाधान की कार्यक्षमता में सुधार, रोग की प्रगति की निगरानी एवं आपके स्क्रीनिंग परिणामों के आधार पर अनुवर्ती जांच शामिल है।<br /><br />
                    सहमति देते हुए, आप निम्न बातों को स्वीकार एवं समझ रहे हैं:<br/><br/>
                    1.  फंडोस्कोपी स्कैन चित्र एवं संबंधित स्वास्थ्य जानकारी (जिसमें आयु, लिंग, मधुमेह की स्थिति, दृष्टि संबंधी समस्याएं एवं रोगी पहचान पत्र शामिल हैं) को स्क्रीनिंग उद्देश्यों के लिए एकत्र किया जाएगा एवं लागू डेटा संरक्षण कानूनों के अनुपालन में एआई मॉडल में सुधार एवं भविष्य के शोध के समर्थन में उपयोग किया जा सकता है।                <br /><br />
                    2.  आपकी भागीदारी पूर्णतः स्वैच्छिक है, एवं आप किसी भी समय अपनी सहमति वापस ले सकते हैं या भागीदारी समाप्त कर सकते हैं।                <br />
                </Typography>
                <Typography
                    paddingX="24px"
                    fontWeight={600}
                    fontSize="18px"
                    component="h4"
                    marginTop="16px"
                >
                    सहमति की घोषणा
                </Typography>
                <Typography
                    paddingX="24px"
                    fontWeight={400}
                    fontSize="16px"
                    marginTop="8px"
                    marginBottom="12px"
                >
                    नीचे दिए गए विकल्पों में से एक चुनकर, आप पुष्टि करते हैं कि आपने दी गई जानकारी को पढ़ एवं समझ लिया है एवं स्वेच्छा से भाग लेने के लिए सहमत हैं:
                </Typography>
                <Typography
                    paddingX="24px"
                    fontWeight={400}
                    fontSize="16px"
                    marginBottom="12px"
                >
                    मैं मधुनेत्रएआई के माध्यम से स्क्रीनिंग के लिए सहमत हूँ एवं अपने डेटा (फंडस चित्र, आयु, लिंग, मधुमेह की स्थिति, दृष्टि संबंधी समस्याएं, रोगी पहचान पत्र) को संग्रहित करने की अनुमति देता/देती हूँ:
                </Typography>
            </Box>
        );
    };

    const getLabelContent = () => {
        return (
          <Box sx={{ paddingX: "24px", mt: 1, mb: 2 }}>
           <RadioGroup
             value={consentType}
             onChange={handleConsentChange}
             sx={{ mt: 1 }}
           >
             {/* ML Consent Radio Button */}
             <FormControlLabel
               value="ml"
               control={
                 <Radio
                   sx={{ "&.Mui-checked": { color: "#0D1E83" } }}
                 />
               }
               label={
                 <Typography fontWeight={400} fontSize="16px" sx={{ lineHeight: 1.5, paddingTop: "2px" }}>
                   {engContent
                     ? "For screening, follow-up services, model improvement, and research"
                     : "स्क्रीनिंग, फॉलो-अप सेवाओं, मॉडल में सुधार और अनुसंधान के लिए।"}
                 </Typography>
               }
               sx={{ mb: 2, alignItems: "center" }}
             />
             
             {/* Basic Consent Radio Button */}
             <FormControlLabel
               value="basic"
               control={
                 <Radio
                   sx={{ "&.Mui-checked": { color: "#0D1E83" } }}
                 />
               }
               label={
                 <Typography fontWeight={400} fontSize="16px" sx={{ lineHeight: 1.5, paddingTop: "2px" }}>
                   {engContent
                      ? "Only for screening and follow-up services"
                      : "केवल स्क्रीनिंग और फॉलो-अप सेवाओं के लिए।"
                      }
                 </Typography>
               }
               sx={{ alignItems: "center" }}
             />
           </RadioGroup>
          </Box>
        );
      };
    

    // CSS for responsive width and scrollability
    const boxStyle = {
        padding: "0px 22px 22px 22px",
        border: "1px solid rgba(0, 0, 0, 0.05)",
        borderRadius: "8px",
        marginX: { sm: "20vw" },
        marginY: "20px",
        width: { sm: "auto" },
        maxHeight: "80vh", // Limit height to enable scrolling
        overflowY: "auto", // Enable scrolling when content overflows
        background: "var(--white, #FFF)",
        boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 6px 0px rgba(0, 0, 0, 0.02)",
    
        '@media (max-width: 900px)': {
            marginX: "0", 
            width: "100vw",
            maxHeight: "90vh", // Higher for mobile screens
            overflowY: "auto",
        }
    };
    

    return (
        <div className="popup">
            <Box
                sx={boxStyle}
                onClick={handlePopupClick}
            >
                <div
                    style={{
                        position: "sticky",
                        top: 0,
                        background: "#FFF",
                        zIndex: 10,
                        paddingTop: "20px",
                        paddingBottom: "10px",
                    }}
                >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginLeft: "24px", marginRight: "24px" }}>
                    <Typography fontWeight="500" fontSize="24px" lineHeight="27.05px">{engContent ? "Informed Consent" : "सूचित सहमति"}</Typography>
                    <Button
                        className='closeButton'
                        endIcon={<CloseIcon />}
                        sx={{ color: "var(--blue, #0D1E83)", borderRadius: "8px", border: "1px solid #0D1E83", textTransform: "none" }}
                        onClick={() => handleExit()}
                    >
                        Close
                    </Button>
                </div>
                <Divider sx={{ marginTop: "10px" }} />
                </div>
                <div style={{ marginTop: "20px", color: "#404040" }}>
                    {engContent ? getEngContent() : getHinContent()}
                </div>
                {/* {isMobile && <div>
                    <Button
                        onClick={handleContentChange}
                        className='contentButton'
                        startIcon={<img src="/assests/images/translate-icon.jpg" alt='Translate' width="17px" height="17px" />}
                        sx={{ borderRadius: "8px", color: "#0D1E83", border: "1px solid #0D1E83" }}
                    >
                        {engContent ? <Typography fontSize="20px" fontWeight="400" align='center'>हिंदी में पढ़ें</Typography> : <Typography fontSize="16px" fontWeight="400" align='center'>Read in English</Typography>}
                    </Button>
                </div>} */}
                <div className="checkboxDiv">
                    {getLabelContent()}
                </div>
                
                <div className='buttonDiv'>
                    <Button
                        onClick={handleContentChange}
                        className='contentButton'
                        startIcon={<img src="/assests/images/translate-icon.jpg" alt='Translate' width="17px" height="17px" />}
                        sx={{ borderRadius: "8px", color: "#0D1E83", border: "1px solid #0D1E83", padding: "0 24px 0 24px" }}
                    >
                        {engContent ? <Typography fontSize="20px" fontWeight="400" align='center' whiteSpace='nowrap'>हिंदी में पढ़ें</Typography> : <Typography fontSize="16px" fontWeight="400" align='center'>Read in English</Typography>}
                    </Button>
                    <Button
                        variant='contained'
                        disabled={!consentType}
                        border="1px solid #7D797B80"
                        fontWeight="400"
                        fontSize="16px"
                        texttransform="none"
                        style={{
                            background: consentType ? 'linear-gradient(270deg, #051572 7.32%, #0820B4 92.68%), linear-gradient(0deg, #FFFFFF, #FFFFFF)' : '',
                            padding: "12px 24px",
                            textTransform: "none",
                            borderRadius: "8px"
                        }}
                        endIcon={<ArrowForwardIcon />}
                        onClick={handleProceed}
                    >
                        Proceed
                    </Button>
                </div>
            </Box>
        </div>
    );
}

export default InformedConsent;
